import { createCrudSlice } from './createCrudSlice';
import { bedroomsApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('bedrooms', bedroomsApi);

export const {
  fetchAll: fetchBedrooms,
  fetchById: fetchBedroomById,
  create: createBedroom,
  update: updateBedroom,
  remove: deleteBedroom,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
